import React from 'react'

import Button from "@mui/material/Button";
import showStyle from "assets/jss/views/picking/order/showStyle";
import { withStyles } from "@mui/styles";

function HeaderActionButton({classes, ...props}) {
    return (
        <Button
            variant="contained"
            disableElevation
            color="primary"
            classes={{root: classes.justificationButton}}
            {...props}
        >
            {props.children}
        </Button>
    )
}

export default (withStyles(showStyle)(HeaderActionButton));
